import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

function AppleIcon({ className }) {
  return (
    <svg viewBox="0 0 384 512" className={className} aria-hidden="true">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
    </svg>
  );
}

function PlayIcon({ className }) {
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
      <path fill="#00D9FF" d="M48 59.5v393c0 5.7 6.5 8.8 11 5.3l232-201.8z" />
      <path fill="#00F076" d="M48 59.5L291 256 357 199 86 41C71 32 48 41 48 59.5z" />
      <path fill="#FFC900" d="M357 199l-66 57 66 57 90-49c14-8 14-28 0-36z" />
      <path fill="#FF3A44" d="M48 452.5L291 256l66 57-271 158c-15 9-38 0-38-18.5z" />
    </svg>
  );
}

function StoreLink({ href, icon, top, bottom, dark, testId }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex min-w-0 items-center justify-center gap-2 rounded-full px-4 py-3 transition-transform duration-200 hover:scale-[1.03] sm:gap-3 sm:px-5 ${
        dark ? "bg-white text-giva-navy hover:bg-white/90" : "bg-giva-navy text-white hover:bg-giva-text"
      }`}
    >
      {icon}
      <span className="flex flex-col items-start leading-none">
        <span className="text-[10px] font-medium opacity-80">{top}</span>
        <span className="font-display text-sm font-bold sm:text-base">{bottom}</span>
      </span>
    </a>
  );
}

export function StoreButtons({ dark = false, className = "", testPrefix = "store" }) {
  const { t } = useI18n();
  return (
    <div className={`grid w-full grid-cols-1 gap-3 min-[420px]:grid-cols-2 sm:flex sm:w-auto sm:flex-wrap sm:items-center ${className}`}>
      <StoreLink
        href={APP_STORE_URL}
        dark={dark}
        testId={`${testPrefix}-appstore-btn`}
        icon={<AppleIcon className="h-6 w-6 fill-current" />}
        top={t("download.app")}
        bottom={t("download.appstore")}
      />
      <StoreLink
        href={GOOGLE_PLAY_URL}
        dark={dark}
        testId={`${testPrefix}-googleplay-btn`}
        icon={<PlayIcon className="h-5 w-5" />}
        top={t("download.play")}
        bottom={t("download.googleplay")}
      />
    </div>
  );
}
